// Auto-generated resource for Audio — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const AudioKeys = {
  Validations: {
    TextRequired: 'Audio.Validations.TextRequired',
    InvalidIntensity: 'Audio.Validations.InvalidIntensity',
    UnknownMood: 'Audio.Validations.UnknownMood',
  },
} as const;

export const AudioValues = {
  'default': {
    'Validations.InvalidIntensity': 'Intensity must be between 0 and 10.',
    'Validations.TextRequired': 'Text is required.',
    'Validations.UnknownMood': 'Unknown mood. Valid values: {0}.',
  },
  'vi-VN': {
    'Validations.InvalidIntensity': 'Cường độ phải nằm trong khoảng từ 0 đến 10.',
    'Validations.TextRequired': 'Cần có nội dung văn bản.',
    'Validations.UnknownMood': 'Tâm trạng không xác định. Giá trị hợp lệ: {0}.',
  },
} as const;

